module.exports = __webpack_public_path__ + "static/media/skjelven.11159469.mp3";